<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/s3fksO/tc-custom/9781504020107.jpg?1705026066067" alt="This image is the cover for the book Uninvited Countess, The Bedford Green Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uninvited Countess, The Bedford Green Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>This murder mystery set amid the social whirl of 1920s Newport “beautifully captures the flavor of the period” (<i>Rendezvous</i>).</b><br/>  <br/> Gossip columnist, gallery owner, amateur sleuth—Bedford Green has been a lot of things, but he’s never been respectable. So on a blistering hot afternoon in 1925, the impeccably dressed man-about-town is shocked to receive an invitation from the Vanderbilts requesting that he spend a few days in their cottage at Newport. By “cottage,” of course, the Vanderbilts mean the Breakers—a seventy-room mansion lavish enough to make King Midas blush.<br/>  <br/> Desperate to escape the rising mercury level in New York City’s Greenwich Village, Green accepts, and brings along his invaluable assistant, Sloane. But out at the Breakers, he’ll find there are more dangerous things than a heat wave. The Vanderbilts have hired Green to investigate the mysterious Countess Zala, an interloper whose arrival has been the talk of the season. But when Green lands at Newport, the countess is found murdered on the beach—and the party is just getting started . . .<br/>  <br/> The Uninvited Countess <i>is the second book in the Bedford Green Mysteries, but you may enjoy reading the series in any order.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Kilian
      </h2>
      
      <p class="authorDescription body article">Michael Kilian (1939&ndash;2005) was born in Toledo, Ohio, and was raised in Chicago, Illinois, and Westchester, New York. He was a longtime columnist for the&#160;<I>Chicago Tribune</I>&#160;in Washington, DC, and also wrote the Harrison Raines Civil War Mysteries. In 1993, with the help of illustrator Dick Locher, Kilian began writing the comic strip&#160;<I>Dick Tracy</I>. Kilian is buried in Arlington National Cemetery.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ff614f80